<template>
    <div class="space-y-4">
        <!-- Sekce 1: Identita -->
        <section>
            <dl class="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-1.5 text-xs">
                <div class="flex">
                    <dt class="text-gray-500 w-32 shrink-0">ID</dt>
                    <dd class="text-ink tabular-nums">{{ zone.id }}</dd>
                </div>
                <div class="flex">
                    <dt class="text-gray-500 w-32 shrink-0">{{ t('zones.fields.name') }}</dt>
                    <dd class="text-ink">{{ zone.name }}</dd>
                </div>
                <div class="flex">
                    <dt class="text-gray-500 w-32 shrink-0">{{ t('zones.fields.validSince') }}</dt>
                    <dd class="text-ink tabular-nums">{{ zone.validSince ?? '—' }}</dd>
                </div>
                <div class="flex">
                    <dt class="text-gray-500 w-32 shrink-0">{{ t('zones.fields.validUntil') }}</dt>
                    <dd class="text-ink tabular-nums">{{ zone.validUntil ?? '—' }}</dd>
                </div>
            </dl>
        </section>

        <!-- Sekce 2: Sloty -->
        <section class="border-t border-gray-200 pt-4">
            <h3 class="text-xs font-semibold uppercase tracking-wider text-gray-500 mb-3">
                {{ t('zones.fields.slots') }} ({{ zone.slots.length }})
            </h3>
            <div v-if="zone.slots.length" class="text-xs space-y-1 max-h-48 overflow-auto font-mono">
                <div v-for="s in zone.slots" :key="s.id" class="text-ink">
                    #{{ s.id }}: {{ s.start }}<span v-if="s.end"> – {{ s.end }}</span>
                </div>
            </div>
            <div v-else class="text-xs text-gray-400">{{ t('zones.fields.noSlots') }}</div>
        </section>

        <!-- Sekce 3: KONFIGURAČNÍ QR -->
        <section class="border-t border-gray-200 pt-4">
            <h3 class="text-xs font-semibold uppercase tracking-wider text-gray-500 mb-3">
                {{ t('zones.qr.title') }}
            </h3>
            <div class="flex items-start gap-4 flex-wrap">
                <QrPreview
                    :code="qrCode"
                    :label="zone.name"
                    :subtitle="`Zóna · ID ${zone.id}`"
                    :size="160"
                />
                <BBtn severity="secondary" size="small" type="button" @click="addToClipboard">
                    {{ t('zones.qr.addToClipboard') }}
                </BBtn>
            </div>
        </section>
    </div>
</template>

<script setup lang="ts">
    import { computed } from 'vue'
    import { useI18n } from 'vue-i18n'
    import BBtn from '@lib/components/base/BBtn.vue'
    import QrPreview from '@lib/components/shared/QrPreview.vue'
    import { useToast } from '@lib/composables/useToast'
    import { buildZonesCode } from '@/lib/configCode'
    import { buildDeepLink } from '@/lib/deepLink'
    import { useClipboardStore } from '@/stores/clipboard'
    import type { Zone } from '@/composables/useZonesData'

    const props = defineProps<{ zone: Zone }>()
    const { t } = useI18n()
    const toast = useToast()
    const clipboard = useClipboardStore()

    const qrCode = computed(() => buildDeepLink(buildZonesCode([props.zone.id])))

    function addToClipboard() {
        clipboard.add({
            kind: 'zones',
            item: { id: props.zone.id, name: props.zone.name }
        })
        toast.success(t('zones.qr.added'))
    }
</script>
